/**
 * Export glyph from the design system: a document tray with an arrow leaving it.
 *
 * The source asset hard-codes #4A606A; this inherits `currentColor` instead so the icon follows
 * the color of whatever label it sits beside.
 */
function ExportRounded(props) {
  return (
    <svg
      aria-hidden='true'
      viewBox='0 0 30 30'
      width='30'
      height='30'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      {/* evenodd carries over from the source asset, which needs it for the tray's cutout. */}
      <g fill='currentColor' fillRule='evenodd'>
        <path d='M21.84 10.364a2.16 2.16 0 0 1 2.16 2.16V25.84A2.16 2.16 0 0 1 21.84 28H8.16A2.16 2.16 0 0 1 6 25.84V12.524a2.16 2.16 0 0 1 2.16-2.16H12v2.204H9.69a1.44 1.44 0 0 0-1.44 1.44v10.348c0 .795.645 1.44 1.44 1.44h10.62a1.44 1.44 0 0 0 1.44-1.44V14.009a1.44 1.44 0 0 0-1.44-1.44H18v-2.205h3.84Z' />
        <path d='m15.564 2.257 3.76 4.735a.72.72 0 0 1-.565 1.168h-2.548v10.302a.72.72 0 0 1-.72.72h-.983a.72.72 0 0 1-.72-.72V8.16H11.24a.72.72 0 0 1-.564-1.167l3.76-4.735a.72.72 0 0 1 1.127 0Z' />
      </g>
    </svg>
  )
}

export default ExportRounded
